import React, { Component } from "react";
import { Helmet } from "react-helmet";
import { Box } from "@mui/material";
import AboutTop from "../../components/about-blocks/about-top";
import Vision from "../../components/about-blocks/vision";
import Experience from "../../components/about-blocks/experience";
import { DataProvider } from "../../context/menucontext";

class About extends Component {
    render() {
        return (
            <Box>
               <DataProvider>
                <Helmet>
                    <title>About Us | F9 Technologies</title>
                    <meta name="description" content="Reach out to Vizag's highly skilled and knowledgeable software expertise." />
                </Helmet>
                <AboutTop/>
                <Vision/>
                <Experience/>
                </DataProvider>
            </Box>
        );
    }
}

export default About;
